<template>
  <div ref="el" :style="{ height }" class="toggle">
    <slot/>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, default: false },
  },
  data: () => ({
    mounted: false,
  }),
  computed: {
    height() {
      if (this.value) {
        return !this.mounted ? 'auto' : `${this.$refs.el.scrollHeight}px`;
      }
      return '0px';
    },
  },
  async mounted() {
    await this.$nextTick();
    this.mounted = true;
  },
};
</script>

<style lang="scss" scoped>
.toggle {
  overflow: hidden;
  transition: height 0.3s ease-in-out;
}
</style>
